import React, { useEffect, useState } from "react";
import { Tags, Factory } from "lucide-react";
import client from "@/lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

const Taxonomies = () => {
  const [cats, setCats] = useState([]);
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    client.get("/categories").then((r) => setCats(r.data.items));
    client.get("/brands").then((r) => setBrands(r.data.items));
  }, []);

  return (
    <div>
      <h1 className="text-2xl font-bold tracking-tight text-graphite">Categories & Brands</h1>
      <p className="text-sm text-steel-light mt-1 mb-6">Hierarchy mirrors the source catalogue so customers recognise their own business.</p>

      <Tabs defaultValue="cats">
        <TabsList>
          <TabsTrigger value="cats" data-testid="tab-categories"><Tags className="w-4 h-4 mr-1.5" /> Categories</TabsTrigger>
          <TabsTrigger value="brands" data-testid="tab-brands"><Factory className="w-4 h-4 mr-1.5" /> Brands</TabsTrigger>
        </TabsList>

        <TabsContent value="cats" className="mt-4 space-y-3">
          {cats.map((c) => (
            <div key={c.slug} className="bg-white border border-border rounded-lg p-4">
              <div className="flex items-center justify-between">
                <span className="font-semibold text-graphite">{c.name}</span>
                <span className="mono text-xs text-steel-light">{c.count} parts</span>
              </div>
              {c.children?.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-3">
                  {c.children.map((sc) => (
                    <span key={sc.slug} className="text-xs bg-surface border border-border rounded px-2 py-1 text-steel">{sc.name} <span className="mono text-steel-light">{sc.count}</span></span>
                  ))}
                </div>
              )}
            </div>
          ))}
        </TabsContent>

        <TabsContent value="brands" className="mt-4">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {brands.map((b) => (
              <div key={b.slug} className="bg-white border border-border rounded-lg p-4 flex items-center justify-between">
                <span className="font-medium text-graphite">{b.name}</span>
                <span className="mono text-xs text-steel-light">{b.count}</span>
              </div>
            ))}
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Taxonomies;
